const AFFECTED_QUERIES = ["vinculos", "plantoes", "dashboard", "kpis", "alertas", "comprovacoes", "onboarding"];

export function invalidateVinculoQueries(queryClient) {
  AFFECTED_QUERIES.forEach((queryKey) => queryClient.invalidateQueries({ queryKey: [queryKey] }));
}
